import devConfig from "./dev.config";
import localConfig from "./local.config";
import prodConfig from "./prod.config";

function getConfig() {
    const environment = import.meta.env.MODE;
    switch (environment) {
        case 'development':
            return devConfig;
        case 'production':
            return prodConfig;
        default:
            return localConfig;
    }
}

export default getConfig();
